import { spec as fontSpec } from './fonts'

/** Specification variables / Type-info variables */
export const typography = {
  ...fontSpec
}
